const prefix = 'MAX-DSL'

/** console日志 **/
const log = (type: 'LOG' | 'WARN' | 'ERROR' | 'INFO', msg: string, ...others: any) => {
  switch (type) {
    case 'INFO':
      console.info(`[${prefix} ${type}]: ${msg}${others.length > 0 ? '\n' : ''}`, ...others)
      break
    case 'WARN':
      console.warn(`[${prefix} ${type}]: ${msg}${others.length > 0 ? '\n' : ''}`, ...others)
      break
    case 'ERROR':
      console.error(`[${prefix} ${type}]: ${msg}${others.length > 0 ? '\n' : ''}`, ...others)
      break
    default:
      console.log(`[${prefix} ${type}]: ${msg}${others.length > 0 ? '\n' : ''}`, ...others)
      break
  }
}

export const Logger = {
  log: (msg: string, ...others: any) => {
    if (globalThis?.__MAX_DSL_DEBUG__) {
      log('LOG', msg, ...others)
    }
  },
  info: (msg: string, ...others: any) => {
    log('INFO', msg, ...others)
  },
  warn: (msg: string, ...others: any) => {
    log('WARN', msg, ...others)
  },
  error: (msg: string, ...others: any) => {
    log('ERROR', msg, ...others)
  },
}

export type ILogger = typeof Logger
